/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { TaskSearchConditionState } from '../state/TaskSearchConditionState'
import TaskEvent from '../../event/TaskEvent'

class TaskSearchConditionStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new TaskSearchConditionState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case TaskEvent.onEditSearchCondition:
        return state.set(payload.name, payload.value)
    }

    return state
  }
}

export default new TaskSearchConditionStore()
